<template>
  <div class="file-wrapper">
    <i v-bind:class="iconClass" @click.prevent="handleFileClick"/>
    <span class="name-wrapper">
      <span class="file-name text-center ml-1 file-link" @click.prevent="handleFileClick">
          <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ file.name }}</span>
              </template>
            <span>{{ file.name }}</span>
          </v-tooltip>
      </span>
    </span>
    <i v-if="!readonly" class="fas fa-trash-alt file-delete-button ml-1" @click="handleDeleteButtonClick"/>
  </div>
</template>

<script>
import _ from 'lodash'
import FormatBytes from '../Filters/FormatBytes'
import {getBaseApiURL} from '@/helpers/baseurl'
import api from '../../api'
import FileSaver from 'file-saver'
import {mapActions} from 'vuex'
import {detectIconClassByMimeType} from '@/components/Files/utils'

export default {
  name: 'Item',
  props: {
    file: Object,
    readonly: Boolean,
    directDownload: Boolean
  },
  filters: {
    FormatBytes
  },
  computed: {
    fileLink() {
      return `${getBaseApiURL()}files/get?id=${this.file.fileId}`
    },
    iconClass() {
      const mimeType = _.get(this.file, 'mimeType', null)
      let iconClass = detectIconClassByMimeType(mimeType)

      return {
        fas: true,
        'file-link': true,
        'file-icon': true,
        [iconClass]: true
      }
    }
  },
  methods: {
    ...mapActions({
      fileViewerOpen: 'fileViewerOpen'
    }),
    handleDeleteButtonClick() {
      this.$emit('delete', this.file.fileId)
    },
    async handleFileClick() {
      this.$emit('click', {
        source: this.fileLink,
        title: this.file.name,
        mimeType: this.file.mimeType
      })

      if (this.directDownload) {
        try {
          let fileData = await api.getFile(this.file.fileId)
          let blob = new Blob([fileData], {type: this.file.mimeType})

          FileSaver.saveAs(blob, this.file.name)
        } catch (e) {
          console.log(`Unable to download report, details: ${e.message}`)
        }
      }
    }
  }
}
</script>

<style scoped>
.file-wrapper {
  margin: 0 10px 0 0;
  position: relative;
  display: flex;
  max-width: 220px;
}

.file-wrapper:hover {
  text-decoration: underline;
}

.name-wrapper {
  max-width: 180px;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.file-icon {
  color: #000000;
  font-size: 14px;
  margin-top: 3px;
}

.file-delete-button {
  margin-top: 3px;
  color: #cacaca;
}

.file-delete-button:hover {
  color: red !important;
  cursor: pointer;
}

.file-link {
  cursor: pointer;
}
</style>